import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NewsContentProps {
    content: string;
    sourceUrl: string;
}

export const NewsContent = ({ content, sourceUrl }: NewsContentProps) => {
    return (
        <div className="prose prose-lg max-w-none mb-16 animate-slide-up stagger-2">
            <p className="text-lg leading-relaxed text-muted-foreground mb-8">
                {content}
            </p>

            {/* Read Full Article CTA */}
            <div className="mt-12 p-8 rounded-2xl bg-card border border-border text-center">
                <h3 className="text-xl font-bold mb-4">Leia a notícia completa</h3>
                <p className="text-muted-foreground mb-6">
                    Continue lendo esta notícia diretamente na fonte original.
                </p>
                <a href={sourceUrl} target="_blank" rel="noopener noreferrer">
                    <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8">
                        <ExternalLink className="w-4 h-4 mr-2" />
                        Acessar
                    </Button>
                </a>
            </div>
        </div>
    );
};
